var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"d-flex"},[_c('TrackList',{staticClass:"track-list",attrs:{"tracks":_vm.favoriteTracks,"put":false,"sort":false,"pull":"clone","queueing":true,"query":_vm.searchQuery,"listActions":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }